module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/thebasicpoint#thebasicpoint"
    }
  }, [_c('strong', [_c('em', [_vm._v("The Basic Point")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("1 The Triumph of Imbalance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lav1"
    }
  }, [_vm._v("America’s Long March Toward Imbalance: 1789–1989")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lav2"
    }
  }, [_vm._v("The End of Thinking: 1989–___?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lav3"
    }
  }, [_vm._v("Over the Edge: From 1989")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lav4"
    }
  }, [_vm._v("From Market Economy to Corporate Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lav5"
    }
  }, [_vm._v("Not Only in America")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lav6"
    }
  }, [_vm._v("A Rant Against Imbalance, Not Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2 From Exploiting Resources to Exploring Our Resourcefulness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lav1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A World That Exploits Its Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lav2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A World That Explores Our Resourcefulness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3 Three Pillars to Support a Balanced Society")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lav1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Consequences of Left and Right")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lav2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Public, Private, and Plural Sectors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lav3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Welcome to the Plural Sector")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lav4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall (and Rise?) of the Plural Sector")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lav5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond Crude, Crass, and Closed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lav6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is a Balanced Society Even Possible?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4 Radical Renewal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lofty Ideals and Lowly Deals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Governments, Not Now")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Expect Miracles from CSR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Look to Plural Sector Movements and Initiatives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Immediate Reversals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Widespread Regeneration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consequential Reforms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toward Balanced Democracy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lav9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope Ahead?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5 You, Me, and We in This Troubled World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05lav1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Opening Our Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05lav2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05lav3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Irene Question")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05lav4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living the Decent Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05lav5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changing the World Over Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/appendix#appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Appendix: Boiling in Our Own Water")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/references#references",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("References")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Index")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Notes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/endeavor#endeavor",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("About This Endeavor")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0